import React, { useContext, useEffect, useState } from 'react';
import {Button, Card, Col, Container, Row, Offcanvas} from "react-bootstrap";
import ColAuthor from "../../components/columns/ColAuthor";
import ColReader from "../../components/columns/ColReader";
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import CreateBook from "../../components/modals/book/CreateBook";
import AssignFull from "../../components/assignmentpages/AssignFull";
import BookFull from "../../components/bookspages/BookFull";
import DashBoardMain from "../../components/userdashboard/DashBoardMain";
import ChatButton from "../../components/chat/ChatButton";
import Loader from "../../components/Loader";
import {
    fetchAssTypes,
    fetchCurrentUserAssigns,
    fetchCurrentUserBooks,
    fetchGenre,
    fetchLanguages, fetchPrices,
    fetchTypes
} from "../../http/bookAPI";
import {PAY_ROUTE} from "../../utils/consts";
import {useNavigate} from "react-router-dom";
import BsrCalcTool from "../../components/tools/BsrCalcTool";
import {getCustomerPortalUrl} from "../../http/userAPI";
import AmazonSuggestions from "../../components/tools/AmazonSuggestions";
import UserWishlist from "../../components/useraccount/UserWishlist";
import {FaListAlt, FaThList} from "react-icons/fa";
import PartnerDashboard from "../../components/useraccount/PartnerDashboard";
import FaqUserDashboard from "../../components/userdashboard/FaqUserDashboard";
import CreatePool from "../../components/poolpages/CreatePool";
import ColPools from "../../components/columns/ColPools";
import PoolFull from "../../components/poolpages/PoolFull";
import PoolItemFull from "../../components/poolpages/PoolItemFull";
import ColPollItems from "../../components/columns/ColPollItems";
import AllUserPolls from "../../components/poolpages/AllUserPolls";
import AllUserPollItems from "../../components/poolpages/AllUserPollItems";
import ToolsInDashboard from "../../components/userdashboard/ToolsInDashboard";
import ProfileInDashboard from "../../components/userdashboard/ProfileInDashboard";
import VirtBalanceLogsInDashboard from "../../components/userdashboard/VirtBalanceLogsInDashboard";
import UsdBalanceLogsInDashboard from "../../components/userdashboard/UsdBalanceLogsInDashboard";
import {getAffiliateAliasByUserIdApi} from "../../http/affiliateAPI";
import {Helmet} from "react-helmet";
import AddBookInDashboard from "../../components/bookspages/AddBookInDashboard";
import EditBookInDashboard from "../../components/bookspages/EditBookInDashboard";
import CommentsInDashboard from "../../components/userdashboard/CommentsInDashboard";
import AccountSuspendedAlert from "../../components/AccountSuspendedAlert";
import AddBookByGrabFromAmazon from "../../components/bookspages/AddBookByGrabFromAmazon";
import StaffMessageDashboard from "../../components/admin/StaffMessageDashboard";
import CurrentPromotions from "../../components/userdashboard/CurrentPromotions";
import {toast} from "react-toastify";
import BookPayDelete from "../../components/bookspages/BookPayDelete";
import AddProductByGrabFromAmazon from "../../components/bookspages/AddProductByGrabFromAmazon";
import AddProductInDashboard from "../../components/bookspages/AddProductInDashboard";
import ChooseAddType from "../../components/bookspages/ChooseAddType";
import DashboardPromotionView from "../../components/userdashboard/DashboardPromotionView";
import TransferBookFromAnotherAccount from "../../components/bookspages/TransferBookFromAnotherAccount";
import AssignmentsBooksInDashboard from "../../components/userdashboard/AssignmentsBooksInDashboard";

const UserDashboard = observer(({Component}) => {
    const [addbookVisible, setAddBookVisible] = useState(false);
    const [selectedAssignObj, setSelectedAssignObj] = useState(null);
    const [loading, setLoading] = useState(true);
    const { user, book, poolStore, affiliateStore } = useContext(Context);
    const setActiveComponent = (value) => user.setActiveComponent(value);
    const navigate = useNavigate();
    const isMobile = window.innerWidth < 980; // или useMediaQuery
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(false);
    const [showLeftPolls, setShowLeftPolls] = useState(false);
    const [showRightPollItems, setShowRightPollItems] = useState(false);
    const [showMobileTools, setShowMobileTools] = useState(false);
    const dashboardNavButtonClass = (activeComponents) => {
        const components = Array.isArray(activeComponents) ? activeComponents : [activeComponents];
        return `btn btn-outline-success btn-sm ${components.includes(user?.activeComponent) ? "active" : ""}`;
    };

    const handleGoToCustomerPortal = async () => {
        const url = await getCustomerPortalUrl(user?.user?.stripe_customer_id);
        if (url) {
            window.open(url, "_blank"); // 🔥 Открываем в новой вкладке
        }
    };


    /* global gtag */
    useEffect(() => {
        if (typeof gtag === 'function') {
            gtag('event', 'conversion', {
                'send_to': 'AW-16938448441/l9UACL2LzKwaELns8Iw_',
                'value': 1.0,
                'currency': 'UAH'
            });
        }
    }, []);

    useEffect(() => {
        if (user?.user?.id) {
            fetchCurrentUserBooks(user.user.id)
                .then(data => {
                    book.setCurrentUserBooks(data);

                })
                .catch(err => console.error("Error:", err));
        }
    }, [book, user?.user?.id, book?.selectedCurrentUserBook]);

    useEffect(() => {
        if (user?.user?.id) {
            book?.loadUserBookRatings(user?.user?.id);
        }
    }, [book, user?.user?.id])

    useEffect(() => {
        const loadData = async () => {

            if (user?.user?.tariff_plan === "SUSPENDED") {
                toast.error("This Account is Suspended or Deleted. Please Contact Support.", { closeOnClick: true, pauseOnHover: true, draggable: true, theme: "colored", position: "bottom-center", autoClose: 3000, hideProgressBar: false })
                return;
            }



            setLoading(true); // Начинаем загрузку

            await Promise.all([
                fetchGenre().then(data => book?.setGenres(data)),
                fetchTypes().then(data => book?.setTypes(data)),
                fetchAssTypes().then(data => book?.setAssTypes(data)),
                fetchLanguages().then(data => book?.setLanguages(data)),
                fetchPrices().then(data => book?.setPrices(data)),
                fetchCurrentUserAssigns(user?.user?.id).then(data => book.setCurrentUserAssigns(data)),
                fetchCurrentUserBooks(user?.user?.id).then(data => book.setCurrentUserBooks(data)),

                user?.user?.id
                    ? getAffiliateAliasByUserIdApi(user.user.id).then(data => affiliateStore.setReferrerData(data))
                    : Promise.resolve(), // ничего не делаем, но промис обязателен
            ]);

            // ⏱ Искусственная задержка 1000мс после всех загрузок
            await new Promise(resolve => setTimeout(resolve, 1000));

            setLoading(false); // Завершаем загрузку
        };

        loadData();
    }, [affiliateStore, book, user?.user?.id, user?.user?.tariff_plan]);




    useEffect(() => {
        setLoading(true);

        if (poolStore?.selectedPool?.id) {
            user.setActiveComponent("PoolFull");
        }

        if (poolStore?.selectedPoolItem?.id) {
            user.setActiveComponent("PoolItemFull");
        }
       setLoading(false);
    }, [book, poolStore, user, book?.selectedCurrentUserAssign.id, poolStore?.selectedPool?.id, poolStore?.selectedPoolItem?.id]);

    const handleBookSelect = (bookobject) => {
        book.setSelectedCurrentUserAssign({});
        poolStore?.setSelectedPool({});
        poolStore?.setSelectedPoolItem({});
        user.setActiveComponent("BookFull");
    };

    const handlePoolSelect = (pool) => {
        book.setSelectedCurrentUserAssign({});
        book.setSelectedCurrentUserBook({});
        poolStore?.setSelectedPoolItem({});
        poolStore?.setSelectedPool(pool);
        user.setActiveComponent("PoolFull");

    };

    const handlePoolItemSelect = (poolitem) => {
        book.setSelectedCurrentUserAssign({});
        book.setSelectedCurrentUserBook({});
        poolStore?.setSelectedPool({});
        poolStore?.setSelectedPoolItem(poolitem);
        user.setActiveComponent("PoolItemFull");
        console.log("Selected pool item:", poolitem);
        console.log(user?.activeComponent);
    };

    const handleAssignSelect = () => {
        book.setSelectedCurrentUserBook({});
        poolStore?.setSelectedPool({});
        poolStore?.setSelectedPoolItem({});
        setSelectedAssignObj(book.selectedCurrentUserAssign);
        user.setActiveComponent("AssignFull");
    };
    const isSuspendedUser = user.user?.tariff_plan === "SUSPENDED";

    return (
        <Container fluid style={{ padding: 15, marginTop: -37 }}>
            {loading ? (
                <Loader />
            ) : (
                <>

                                <Helmet>
                        <title>Virtalibry Dashboard – Manage Reviews, Books & Reader Insights</title>
                        <meta
                            name="description"
                            content="Welcome to your Virtalibry Dashboard – upload books, track Amazon reviews, manage Virts, launch reader polls, and test your book titles and covers. Built for authors & publishers."
                        />
                        <meta
                            name="keywords"
                            content="Virtalibry dashboard, KDP reviews, book marketing tools, reader polls, Amazon feedback, author tools, test book covers, royalty calculator, Amazon suggestions"
                        />
                        <meta property="og:title" content="Virtalibry Dashboard – Tools for Authors to Grow on Amazon" />
                        <meta property="og:description" content="Manage your books, track reviews, earn and spend Virts, run polls, and get insights to boost your success on Amazon." />
                        <meta property="og:type" content="website" />
                        <meta property="og:url" content="https://virtalibry.com/dashboard" />
                        <meta property="og:image" content="https://virtalibry.com/face/why_love_is_gold_new.png" />

                        <meta name="twitter:card" content="summary_large_image" />
                        <meta name="twitter:title" content="Virtalibry Author Dashboard" />
                        <meta name="twitter:description" content="Upload books, receive verified reviews, launch polls and analyze what makes your book perform better." />
                        <meta name="twitter:image" content="https://virtalibry.com/face/why_love_is_gold_new.png" />

                        <link rel="canonical" href="https://virtalibry.com/dashboard" />

                        {/* Structured Data: WebApplication for Google */}
                        <script type="application/ld+json">
                            {`
        {
          "@context": "https://schema.org",
          "@type": "WebApplication",
          "name": "Virtalibry Dashboard",
          "url": "https://virtalibry.com/dashboard",
          "description": "Authors use the Virtalibry Dashboard to track Amazon reviews, earn and use Virts, run cover/title polls, and get marketing insights.",
          "applicationCategory": "ProductivityApplication",
          "operatingSystem": "All",
          "publisher": {
            "@type": "Organization",
            "name": "Virtalibry"
          }
        }
        `}
                        </script>

                        {/* Structured Data: FAQ Snippet for Search */}
                        <script type="application/ld+json">
                            {`
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "How do I use the Virtalibry Dashboard?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The dashboard allows you to upload your books, view review progress, manage Virts, and create polls to test your book marketing."
              }
            },
            {
              "@type": "Question",
              "name": "What are Virts and how do I earn them?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Virts are the internal currency of Virtalibry. You earn them by reviewing other books, and you can use them to receive reviews or launch polls."
              }
            },
            {
              "@type": "Question",
              "name": "Can I test book covers in the dashboard?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, with our poll feature, you can test multiple book covers or titles and see what resonates most with readers before publishing."
              }
            }
          ]
        }
        `}
                        </script>
                    </Helmet>

                    {isSuspendedUser ? (
                        <>
                        <AccountSuspendedAlert onOpenCustomerPortal={handleGoToCustomerPortal} />

                        </>
                    ) : (
                        <>

                    {/* Бургер-кнопки только на мобильных */}
                    <div className="d-flex justify-content-between d-lg-none p-2">
                        <Button variant="outline-success" size="sm" onClick={() => setShowLeft(true)}>
                            <i className="bi bi-list"></i> Books/Prod
                        </Button>
                        <Button
                            size="sm"
                            variant="outline-success"
                            onClick={() => setShowMobileTools(true)}
                        >
                            <i className="bi bi-list me-2"></i>Menu
                        </Button>
                        <Button size="sm" variant="outline-success" onClick={() => setShowRight(true)}>
                            Assignments <i className="bi bi-list"></i>
                        </Button>
                    </div>
                    <div className="d-flex justify-content-between d-lg-none p-2">
                        <Button size="sm" variant="outline-success" onClick={() => setShowLeftPolls(true)}>
                            <i className="bi bi-list"></i> Your Polls
                        </Button>

                        <Button size="sm" variant="outline-success" onClick={() => setShowRightPollItems(true)}>
                            Polls You're Taking <i className="bi bi-list"></i>
                        </Button>
                    </div>
                     <Row className="mt-2 ">
                         <Col md={2} className="d-none d-lg-block">
                            <ColAuthor onBookSelect={handleBookSelect} setActiveComponent={setActiveComponent} />
                             <ColPools onPoolSelect={handlePoolSelect} setActiveComponent={setActiveComponent}/>
                        </Col>
                         <Col xs={12} md={12} lg={8}>
                             {/* Мобильная версия подменю */}
                             {isMobile && (
                                 <>


                                     <Offcanvas
                                         show={showMobileTools}
                                         onHide={() => setShowMobileTools(false)}
                                         placement="start"
                                     >
                                         <Offcanvas.Header closeButton>
                                             <Offcanvas.Title>Tools & Navigation</Offcanvas.Title>
                                         </Offcanvas.Header>
                                         <Offcanvas.Body className=" text-center p-4 text-success fw-bold">




                                             <Button
                                                 variant="outline-success"
                                                 className="w-50 me-3 mb-2 text-start"
                                                 onClick={() => {
                                                     user.setActiveComponent("AssignmentsBooksInDashboard");
                                                     setShowMobileTools(false);
                                                 }}
                                             >
                                                 <FaThList className="me-2" />
                                                 Assignments&Books
                                             </Button>
                                             <Button
                                                 variant="outline-success"
                                                 className="w-50 me-3 mb-2 text-start"
                                                 onClick={() => {
                                                     user.setActiveComponent("AllPolls");
                                                     setShowMobileTools(false);
                                                 }}
                                             >
                                                 <FaThList className="me-2" />
                                                 All Your Poll's
                                             </Button>
                                             <Button
                                                 variant="outline-success"
                                                 className="w-50 me-3 mb-2 text-start"
                                                 onClick={() => {
                                                     user.setActiveComponent("AllPollItems");
                                                     setShowMobileTools(false);
                                                 }}
                                             >
                                                 <FaListAlt className="me-2" />
                                                 All Taken Poll's
                                             </Button>
                                             <Button
                                                 variant="outline-success"
                                                 className="w-50 me-3 mb-2 text-start"
                                                 onClick={() => {
                                                     user.setActiveComponent("CommentsInDashboard");
                                                     setShowMobileTools(false);
                                                 }}
                                             >
                                                 <FaListAlt className="me-2" />Comments
                                             </Button>

                                             <Button
                                                 variant="outline-success"
                                                 className="w-50 me-3 mb-2 text-start"
                                                 onClick={() => {
                                                     user.setActiveComponent("Affiliate");
                                                     setShowMobileTools(false);
                                                 }}
                                             >
                                                 <FaListAlt className="me-2" />For Affiliate
                                             </Button>

                                             <Button
                                                 variant="outline-success"
                                                 className="w-50 me-3 mb-2 text-start"
                                                 onClick={() => {
                                                     user.setActiveComponent("ProfileInDashboard");
                                                     setShowMobileTools(false);
                                                 }}
                                             >
                                                 <i className="bi bi-person-circle me-2"></i>User Profile
                                             </Button>
                                             <Button
                                                 variant="outline-success"
                                                 className="w-50 me-3 mb-2 text-start"
                                                 onClick={() => {
                                                     user.setActiveComponent("FAQ");
                                                     setShowMobileTools(false);
                                                 }}
                                             >
                                                 <FaListAlt className="me-2" />Read the FAQ
                                             </Button>

                                             <Button
                                                 variant="outline-success"
                                                 className="w-50 me-3 mb-2 text-start"
                                                 onClick={() => {
                                                     user.setActiveComponent("BsrCalculator");
                                                     setShowMobileTools(false);
                                                 }}
                                             >
                                                 <i className="bi bi-calculator me-2" />BSR Calculator
                                             </Button>

                                             {(user?.user?.tariff_plan === "FREE") ? (
                                                 <Button
                                                     variant="outline-success"
                                                     className="w-50 me-3 mb-2 text-start"
                                                     onClick={() => {
                                                         navigate(PAY_ROUTE);
                                                         setShowMobileTools(false);
                                                     }}
                                                 >
                                                     <i className="bi bi-star me-2" />Get Premium
                                                 </Button>
                                             ) : (
                                                 <Button
                                                     variant="outline-success"
                                                     className="w-50 me-3 mb-2 text-start"
                                                     onClick={() => {
                                                         handleGoToCustomerPortal();
                                                         setShowMobileTools(false);
                                                     }}
                                                 >
                                                     <i className="bi bi-credit-card me-2" />Subscription
                                                 </Button>
                                             )}



                                             {/* И остальные кнопки по аналогии */}
                                         </Offcanvas.Body>
                                     </Offcanvas>
                                 </>
                             )}



                             <Card className={`p-2 shadow-lg mt-0 d-none d-lg-block`}>
                                <div className="w-auto">
                                    <div className="d-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "0.5rem" }}>
                                    <div className="btn-group" role="group" aria-label="Small outlined success buttons">
                                        <button type="button" className={dashboardNavButtonClass("MainPageDashboard")} onClick={() => user.setActiveComponent("MainPageDashboard")}>
                                            <i className="bi bi-speedometer2 me-2"></i>
                                            Dashboard
                                        </button>

                                        <button type="button" className={dashboardNavButtonClass(["AssignmentsBooksInDashboard", "BookUserList", "AssignUserList"])} onClick={() => user.setActiveComponent("AssignmentsBooksInDashboard")}>
                                            <FaThList className="me-2" />
                                            Assignments&Books
                                        </button>

                                        <button type="button" className={dashboardNavButtonClass("AllPolls")} onClick={() => user.setActiveComponent("AllPolls")}>
                                            <FaThList className="me-2" />
                                            Poll's
                                        </button>

                                        <button type="button" className={dashboardNavButtonClass("AllPollItems")} onClick={() => user.setActiveComponent("AllPollItems")}>
                                            <FaListAlt className="me-2" />
                                            Taken Poll's
                                        </button>

                                        {(user?.user?.tariff_plan === "FREE") ? (
                                            <button type="button" className="btn btn-outline-success btn-sm" onClick={() => navigate(PAY_ROUTE)}>
                                                <i className="bi bi-star me-2"></i>
                                                Get Premium
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                className="btn btn-outline-success btn-sm"
                                                onClick={handleGoToCustomerPortal}
                                            >
                                                <i className="bi bi-credit-card me-2"></i>
                                                Customer Portal
                                            </button>
                                        )}

                                        <button type="button" className={dashboardNavButtonClass("Affiliate")} onClick={() => user.setActiveComponent("Affiliate")}>
                                            <FaListAlt className="me-2" />
                                            Affiliate
                                        </button>

                                        <button type="button" className={dashboardNavButtonClass("ProfileInDashboard")} onClick={() => user.setActiveComponent("ProfileInDashboard")}>
                                            <i className="bi bi-person-circle me-2"></i>
                                            {isMobile ? 'Profile' : 'Profile'}
                                        </button>
                                        <button type="button" className={dashboardNavButtonClass("ToolsInDashboard")} onClick={() => user.setActiveComponent("ToolsInDashboard")}>
                                            <i className="bi bi-tools me-2"></i>
                                            Tools
                                        </button>
                                        <button type="button" className={dashboardNavButtonClass("CommentsInDashboard")} onClick={() => user.setActiveComponent("CommentsInDashboard")}>
                                            <i className="bi bi-chat-dots me-2"></i>
                                            Comments
                                        </button>
                                    </div>
                                </div>
                                </div>
                            </Card>
                             <StaffMessageDashboard />
                             <CurrentPromotions />
                             {user?.activeComponent === "BookPayDelete" && (
                                 <BookPayDelete
                                     bookId={book?.selectedCurrentUserBook?.id}
                                     bookData={book?.selectedCurrentUserBook}
                                     onSuccess={async () => {
                                         try {
                                             // 1) обновляем список книг пользователя
                                             const uid = user?.user?.id;
                                             if (uid) {
                                                 const data = await fetchCurrentUserBooks(uid);
                                                 book.setCurrentUserBooks(data);
                                             }

                                             // 2) если удаляли текущую выбранную — сбросим выбор
                                             if (book?.selectedCurrentUserBook?.id) {
                                                 book.setSelectedCurrentUserBook(null); // если у тебя есть такой экшен
                                             }
                                         } finally {
                                             // 3) возвращаемся в дашборд
                                             user.setActiveComponent("MainPageDashboard");
                                         }
                                     }}
                                 />
                             )}
                             {user?.activeComponent === "VirtBalanceLogs" && <VirtBalanceLogsInDashboard />}
                             {user?.activeComponent === "EditBookInDashboard" && <EditBookInDashboard bookData={book?.selectedCurrentUserBook}/>}
                             {user?.activeComponent === "AddBookInDashboard" && <AddBookInDashboard />}
                             {user?.activeComponent === "AddBookByGrabFromAmazon" && <AddBookByGrabFromAmazon />}
                             {user?.activeComponent === "AddProductInDashboard" && <AddProductInDashboard />}
                             {user?.activeComponent === "AddProductByGrabFromAmazon" && <AddProductByGrabFromAmazon />}
                             {user?.activeComponent === "ChooseAddTypePage" && <ChooseAddType />}
                             {user?.activeComponent === "TransferBookFromAnotherAccount" && <TransferBookFromAnotherAccount />}
                             {user?.activeComponent === "UsdBalanceLogs" && <UsdBalanceLogsInDashboard />}
                             {user?.activeComponent === "ProfileInDashboard" && <ProfileInDashboard />}
                             {user?.activeComponent === "ToolsInDashboard" && <ToolsInDashboard />}
                            {user?.activeComponent === "MainPageDashboard" && <DashBoardMain />}
                            {user?.activeComponent === "DashboardPromotion" && (
                                <DashboardPromotionView onBack={() => user.setActiveComponent("MainPageDashboard")} />
                            )}
                            {user?.activeComponent === "BsrCalculator" && <BsrCalcTool />}
                            {user?.activeComponent === "AmazonSuggestions" && <AmazonSuggestions />}
                            {user?.activeComponent === "WishList" && <UserWishlist />}
                            {user?.activeComponent === "Affiliate" && <PartnerDashboard />}
                            {user?.activeComponent === "FAQ" &&  <FaqUserDashboard />}
                             {user?.activeComponent === "CommentsInDashboard" &&  <CommentsInDashboard />}
                             {["AssignmentsBooksInDashboard", "BookUserList", "AssignUserList"].includes(user?.activeComponent) && (
                                 <AssignmentsBooksInDashboard
                                     onBookSelect={handleBookSelect}
                                     onAssignSelect={handleAssignSelect}
                                     setActiveComponent={setActiveComponent}
                                 />
                             )}
                            {user?.activeComponent === "BookFull" && <BookFull bookobject={book?.selectedCurrentUserBook} setActiveComponent={setActiveComponent} compMode={book?.selectedCurrentUserBook?.book_type} />}
                            {user?.activeComponent === "AssignFull" && <AssignFull assignobject={selectedAssignObj}  />}
                            {user?.activeComponent === "PoolFull" && <PoolFull pool={poolStore?.selectedPool} setActiveComponent={setActiveComponent} />}
                            {user?.activeComponent === "CreatePool" && <CreatePool setActiveComponent={setActiveComponent} />}
                            {user?.activeComponent === "PoolItemFull" && <PoolItemFull pollItem={poolStore?.selectedPoolItem} setActiveComponent={setActiveComponent} />}
                            {user?.activeComponent === "AllPolls" && <AllUserPolls onPoolSelect={handlePoolSelect} setActiveComponent={setActiveComponent} />}
                            {user?.activeComponent === "AllPollItems" && <AllUserPollItems onPoolItemSelect={handlePoolItemSelect} setActiveComponent={setActiveComponent} />}
                         </Col>
                         <Col md={2} className="d-none d-lg-block">
                            <ColReader onAssignSelect={handleAssignSelect} setActiveComponent={setActiveComponent} />
                             <ColPollItems onPoolItemSelect={handlePoolItemSelect} setActiveComponent={setActiveComponent}/>
                        </Col>
                    </Row>
                    <CreateBook show={addbookVisible} handleClose={() => setAddBookVisible(false)} />
                    <ChatButton />
                    {/* Мобильные оффканвас панели */}

                    {/* Книги (слева) */}
                    <Offcanvas show={showLeft} onHide={() => setShowLeft(false)} placement="start">
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Books/Prod.</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <ColAuthor
                                onBookSelect={handleBookSelect}
                                setActiveComponent={setActiveComponent}
                                onClose={() => setShowLeft(false)} // ← вот она!
                            />
                        </Offcanvas.Body>
                    </Offcanvas>

                    {/* Задания (справа) */}
                    <Offcanvas show={showRight} onHide={() => setShowRight(false)} placement="end">
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Assignments</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <ColReader onAssignSelect={handleAssignSelect}
                                       setActiveComponent={setActiveComponent}
                                       onClose={() => setShowRight(false)} // ← вот она!
                             />
                        </Offcanvas.Body>
                    </Offcanvas>

                    {/* Опросы (слева) */}
                    <Offcanvas show={showLeftPolls} onHide={() => setShowLeftPolls(false)} placement="start">
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Your Polls</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <ColPools
                                onPoolSelect={handlePoolSelect}
                                setActiveComponent={setActiveComponent}
                                onClose={() => setShowLeftPolls(false)} // ← вот она!
                            />
                        </Offcanvas.Body>
                    </Offcanvas>
                    {/* Взятые Опросы (справа) */}
                    <Offcanvas show={showRightPollItems} onHide={() => setShowRightPollItems(false)} placement="end">
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Polls You're Taking</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <ColPollItems
                                onPoolItemSelect={handlePoolItemSelect}
                                setActiveComponent={setActiveComponent}
                                onClose={() => setShowRightPollItems(false)} // ← вот она!
                            />
                        </Offcanvas.Body>
                    </Offcanvas>
                </>
            )}
                </>
            )}

        </Container>
    );
});

export default UserDashboard;
